<template>
  <modal id="show-content-modal">
    <template v-slot:header>{{ title }}</template>
    <div class="modal-body p-0">
      <div class="details-container p-4 border rounded">
        {{ content }}
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["title", "content"],
};
</script>
